export default __webpack_public_path__ + "static/media/login22.aebefb10.png";